/**
 * 全局指令
 */

import Vue from 'vue'
import initStyle from './initStyle'
import infiniteScroll from 'vue-infinite-scroll'

// 翻页指令
Vue.use(infiniteScroll)

Vue.directive('init-page-height', {
  componentUpdated: function (el) {
    initStyle.initPageHeight(el)
  },
  inserted: function (el) {
    initStyle.initPageHeight(el)
  }
})
// 初始化list宽度
Vue.directive('list-width-init', {
  componentUpdated: function (el) {
    initStyle.listWidthInit(el)
  },
  inserted: function (el) {
    initStyle.listWidthInit(el)
  }
})
// 显示隐藏弹窗
Vue.directive('modal-show', {
  componentUpdated: function (el, binding) {
    initStyle.modalShow(el, binding)
  },
  inserted: function (el, binding) {
    initStyle.modalShow(el, binding)
  },
  unbind: function (el) {
    initStyle.modalHide(el)
  }
})
// 显示隐藏toast
Vue.directive('toast-show', {
  componentUpdated: function (el, binding) {
    initStyle.toastShow(el, binding)
  },
  inserted: function (el, binding) {
    initStyle.toastShow(el, binding)
  },
  unbind: function (el) {
    initStyle.toastHide(el)
  }
})
// 容器文字过长显示省略号
Vue.directive('text-clip-init', {
  componentUpdated: function (el) {
    initStyle.textClipInit(el)
  },
  inserted: function (el) {
    initStyle.textClipInit(el)
  }
})
// 容器文字过长保留空白
Vue.directive('text-clip-init-pre', {
  componentUpdated: function (el) {
    initStyle.textClipInitPre(el)
  },
  inserted: function (el) {
    initStyle.textClipInitPre(el)
  }
})

// 首页最近初始化宽度
Vue.directive('width-init-user-game', {
  componentUpdated: function (el, binding) {
    initStyle.widthInitUserGame(el, binding)
  },
  inserted: function (el, binding) {
    initStyle.widthInitUserGame(el, binding)
  }
})
// 首页预约初始化宽度
Vue.directive('width-init-reserve', {
  componentUpdated: function (el) {
    initStyle.widthInitReserve(el)
  },
  inserted: function (el) {
    initStyle.widthInitReserve(el)
  }
})
// 用户中心最近玩过初始化宽度
Vue.directive('width-init-user-recent', {
  componentUpdated: function (el) {
    initStyle.widthInitUserRecent(el)
  }
})
// 自动获取焦点指令
Vue.directive('focus', {
  inserted: function (el, value) {
    if (value) {
      el.focus()
    }
  }
})



// WEBPACK FOOTER //
// ./src/v2/static/js/directive.js